import {Lang} from 'yougile-lang'
import {
  DataObjectId,
  Hub,
  RepeatStickerEntry,
  StickerType,
  Tag
} from 'yougile-model'
import {showConfirm} from '@components/common/base/notifications'
import {isMirroredHub} from '@extensions/mirrored-tasks/is-mirrored-hub'
import {EventBus} from '../../../client/event-bus'
import {openRepeatTemplatesEvent} from '../../../client/events'
import {RepeatClient} from '../../../client/repeat-client'
import {Sync} from '../../../client/sync'
import {MessageBox} from '../../../components/message-box'
import {PageService} from '../../page-service'
import {StickerContainerKey} from '../views-web/a-sticker-view'
import {ASystemStickerCtl} from './a-system-sticker-ctl'

export class RepeatCtl extends ASystemStickerCtl<RepeatStickerEntry> {
  public requestedValue: {taskId: DataObjectId; container: StickerContainerKey}

  public override onBeforePin(
    task: Hub,
    _tag: Tag,
    value: RepeatStickerEntry
  ): boolean {
    if (isMirroredHub(task)) {
      MessageBox.warn(Lang.msg.mirroredTasks.disallowRepeatTask, {timer: 7000})
      return false
    }

    const box = Sync.get(task)
    if (RepeatClient.canEditRepeatTasks(box, task.location)) {
      if (value) {
        return true
      }
      void showConfirm(Lang.msg.repeat.createTemplateFromTask).then(answer => {
        if (answer) {
          EventBus.dispatch(
            openRepeatTemplatesEvent({
              boardId: PageService.getCurrentBoard()?.id,
              fromTaskId: task.id
            })
          )
        }
      })
    } else {
      MessageBox.warn(Lang.msg.repeat.permissionWarn)
    }
    return false
  }

  public override get title(): string {
    return 'Repeat'
  }

  public get type(): StickerType {
    return 'repeat'
  }

  public displayedTitle(_: Tag): string {
    return Lang.msg.repeat.stickerName
  }
}
